// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1SjvG","subheader":"ReorderModal_subheader__31jCt","listWrap":"ReorderModal_listWrap__3mN0-"};